import React, { useState } from 'react';

import {
  ExternalLink,
  ListContainer,
  ListRowContainer,
  MainTrackPresentationContainer,
  OwnedIndex,
  OwnerContainer,
  TrackDescriptionContainer,
  ViewAllButton
} from '../../styles/TrackPresentation.styled';

import { GenericContentContainer } from './GenericContentContainer';
import { ArtistMetrics } from './ArtistMetrics';
import { SongMetrics } from './SongMetrics';

import ArtistArtwork from '../../assets/Images/ArtistArtwork.png';
import OwnerAvatar from '../../assets/Avatars/Avatar1.svg';

export const TrackPresentation = () => {
  const [isListCollapsed, setListCollapsed] = useState<boolean>(true);

  const handleOnclickViewAll = () => {
    setListCollapsed(!isListCollapsed);
  };

  return (
    <MainTrackPresentationContainer>
      <TrackDescriptionContainer>
        <GenericContentContainer title="Track description">
          Take a high dose of Vitamin D with this sun drenched track,
          'Surfside', a melancholic yet very groovy ballad mixing jazz harmony,
          kicked back beats, airy guitars and old school keys. <br />
          <br />
          RMZ brought the A team on this one with Léon Phal, Ian Ewing and
          Nicolas Felices bringing their own flavors to this music remedy.
        </GenericContentContainer>
        <SongMetrics
          releaseDate="31/01/2022"
          genre="Jazz/Indie"
          duration="2:42"
        />
        <ArtistMetrics
          artistName="RMZ"
          monthlyListener="50K"
          totalStreams="1M"
          socialFollowers="7K"
          artistArtworkLink={ArtistArtwork}
        />
        <GenericContentContainer title="NFT Details">
          <>
            <ListRowContainer>
              <span>Contract</span>
              <ExternalLink
                href="https://ropsten.etherscan.io/address/0x5c5ca3a3396dc2927ca9aaf1ee427c9859085f41"
                target="_blank"
                rel="noopener"
              >
                0x...0c32 ↗︎
              </ExternalLink>
            </ListRowContainer>
            <ListRowContainer>
              <span>Blockchain</span>
              <span>Ethereum</span>
            </ListRowContainer>
            <ListRowContainer>
              <span>Token Standard</span>
              <span>ERC721</span>
            </ListRowContainer>
            <ListRowContainer>
              <span>Legal Contract</span>
              <ExternalLink
                href="https://www.lipsum.com/"
                target="_blank"
                rel="noopener"
              >
                Read ↗︎
              </ExternalLink>
            </ListRowContainer>
          </>
        </GenericContentContainer>
      </TrackDescriptionContainer>
      <TrackDescriptionContainer>
        <GenericContentContainer title="Digsters">
          <ListContainer isCollapsed={isListCollapsed}>
            {Array.from({ length: 180 }, (_, i) => i + 1).map((index) => {
              return (
                <ListRowContainer key={index}>
                  <OwnerContainer>
                    <img src={OwnerAvatar} alt="Owner Avatar" />
                    <span>0x763d…f39E52</span>
                  </OwnerContainer>
                  <OwnedIndex>{index}/180</OwnedIndex>
                </ListRowContainer>
              );
            })}
          </ListContainer>
          {isListCollapsed ? (
            <ViewAllButton onClick={handleOnclickViewAll}>
              View All
            </ViewAllButton>
          ) : (
            <ViewAllButton onClick={handleOnclickViewAll}>
              View Less
            </ViewAllButton>
          )}
        </GenericContentContainer>
      </TrackDescriptionContainer>
    </MainTrackPresentationContainer>
  );
};
